"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var native_1 = (0, tslib_1.__importDefault)(require("./native"));
var constants_1 = require("../../../../../constants");
var defaultPlaybackAdapters = [
    (0, native_1.default)(constants_1.MediaStreamType.HLS, constants_1.MediaStreamDeliveryPriority.NATIVE_ADAPTIVE),
    (0, native_1.default)(constants_1.MediaStreamType.DASH, constants_1.MediaStreamDeliveryPriority.NATIVE_ADAPTIVE),
    (0, native_1.default)(constants_1.MediaStreamType.MP4, constants_1.MediaStreamDeliveryPriority.NATIVE_PROGRESSIVE),
    (0, native_1.default)(constants_1.MediaStreamType.WEBM, constants_1.MediaStreamDeliveryPriority.NATIVE_PROGRESSIVE),
    (0, native_1.default)(constants_1.MediaStreamType.OGG, constants_1.MediaStreamDeliveryPriority.NATIVE_PROGRESSIVE),
    (0, native_1.default)(constants_1.MediaStreamType.MOV, constants_1.MediaStreamDeliveryPriority.NATIVE_PROGRESSIVE),
    (0, native_1.default)(constants_1.MediaStreamType.MKV, constants_1.MediaStreamDeliveryPriority.NATIVE_PROGRESSIVE),
];
exports.default = defaultPlaybackAdapters;
//# sourceMappingURL=default-set.js.map